import { ref } from 'vue'

const screenWidth = ref(0)

const breakpoints = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  max: 1920,
}

const isMobile = computed(() => screenWidth.value < breakpoints.sm)

const onResize = () => {
  screenWidth.value = window?.innerWidth
}

export function init() {
  window?.addEventListener('resize', onResize)
  onResize()
}

export { isMobile }
